import React from 'react';
import { Alert, Button, theme } from 'antd';
import { Link } from 'react-router-dom';

import { useGetGscIntegrationsStatusQuery } from './api/gscApiSlice';
import { usePrerenderUserId } from '../../hooks/usePrerenderUser';

const LOCAL_STORAGE_KEY = 'gsc-integration/banner-closed';

function getLocalStorageKey(prerenderUserId: number) {
  return `${LOCAL_STORAGE_KEY}-${prerenderUserId}`;
}

function loadBannerClosedStatus(prerenderUserId: number) {
  const value = localStorage.getItem(getLocalStorageKey(prerenderUserId));
  return !!value && value === 'true';
}

function saveBannerClosedStatus(prerenderUserId: number, status: boolean) {
  localStorage.setItem(getLocalStorageKey(prerenderUserId), status.toString());
}

function BannerWithLink() {
  const { token } = theme.useToken();
  const { data: gscIntegrationStatus } = useGetGscIntegrationsStatusQuery();
  const prerenderUserId = usePrerenderUserId();

  const isClosed = loadBannerClosedStatus(prerenderUserId);

  if (gscIntegrationStatus?.data?.isConnected || isClosed) return null;

  const onClose = () => {
    saveBannerClosedStatus(prerenderUserId, true);
  };

  return (
    <div style={{ marginBottom: token.marginMD }}>
      <Alert
        message="Connect Google Search Console to automatically discover and import your sitemaps."
        type="info"
        showIcon
        action={
          <Link to="/integrations">
            <Button>Connect GSC</Button>
          </Link>
        }
        closable
        afterClose={onClose}
      />
    </div>
  );
}

export default BannerWithLink;
